import axios from "axios";

const putAppointment = async (baseUrl, token, doctorId, appointmentId, appointment) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.put(baseUrl + "/doctor/" + doctorId + "/appointment/" + appointmentId, appointment, config)
        .then((res) => {
            putResponse = {
                status: res.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    data:  error.response.message
                }
            }
        });
    return putResponse
}

export default putAppointment;